<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  hideRightSide?: boolean;
  hideLeftSide?: boolean;
}>();

const isSplit = computed(() => !props.hideRightSide && !props.hideLeftSide);
</script>

<template>
  <div class="flex min-h-0 flex-1 flex-col gap-4">
    <div class="flex shrink-0 flex-col gap-3">
      <slot name="alerts" />
    </div>
    <div
      v-if="!hideLeftSide || !hideRightSide"
      class="flex min-h-0 flex-1 gap-6"
      :class="isSplit ? 'flex-row' : 'flex-col'"
    >
      <section
        v-if="!hideLeftSide"
        class="flex min-h-0 min-w-0 flex-1 flex-col"
      >
        <slot name="left" />
      </section>
      <div v-if="isSplit" class="border-r border-gray-200 dark:border-gray-700" />
      <section
        v-if="!hideRightSide"
        class="flex min-h-0 min-w-0 flex-1 flex-col"
      >
        <slot name="right" />
      </section>
    </div>
  </div>
</template>
